import CustomModalFooter from 'components/Custom/CustomModalFooter'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { FormGroup, Input, Modal, ModalBody } from 'reactstrap'
import { updateAdmins } from 'store/CustomReports/actions'
import { sendEmailReport } from 'store/CustomReports/actions'
import { updateSharedReport } from 'store/CustomReports/actions'
import { fetchAdmins } from 'store/CustomReports/actions'
import Select from 'views/pages/Select'

function ShareModal({ modalState, setModalState }) {
  const { admins } = useSelector((store) => store.customReports)
  const [emailReport, setEmailReport] = useState(modalState?.email_report)
  const [emailFrequency, setEmailFrequency] = useState(
    modalState?.email_frequency
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (!modalState?.reportId) return
    dispatch(fetchAdmins(modalState?.reportId))
  }, [dispatch, modalState?.reportId])

  useEffect(() => {
    if (!emailFrequency) {
      setEmailFrequency('1 d')
    }
  }, [emailFrequency])

  const enableSendEmailButton = admins.filter((admin) => admin.selected).length

  return (
    <Modal
      toggle={() => setModalState({ show: false, reportId: null })}
      isOpen={modalState.show}
      centered
      size='lg'
    >
      <CustomModalHeader
        title='Share Report'
        toggle={() => setModalState({ show: false, reportId: null })}
      />
      <ModalBody>
        {admins && admins.length
          ? admins.map((admin) => (
              <div className='d-flex justify-content-between align-items-center my-2'>
                <div
                  key={admin.id}
                  className={`custom-control custom-checkbox`}
                  style={{ zIndex: '0' }}
                >
                  <input
                    value={admin.username}
                    className='custom-control-input'
                    id={admin.username}
                    checked={admin?.selected}
                    onChange={(e) => {
                      dispatch(updateAdmins(admin.id, 'share'))
                    }}
                    type='checkbox'
                  />
                  <label
                    className='custom-control-label'
                    htmlFor={admin.username}
                  >
                    {admin.first_name} {admin.last_name}{' '}
                    <small className='ml-2'>({admin.username})</small>
                  </label>
                </div>
                <div className={`${!admin?.selected ? 'invisible' : ''}`}>
                  <Select
                    options={[
                      { name: 'Viewer', value: 0 },
                      { name: 'Editor', value: 1 },
                    ]}
                    onChange={(e) => {
                      dispatch(updateAdmins(admin.id, 'edit'))
                    }}
                    placeholder={admin?.edit_mode ? 'Editor' : 'Viewer'}
                    selectedOption={
                      admin?.edit_mode
                        ? { name: 'Editor', value: 1 }
                        : { name: 'Viewer', value: 0 }
                    }
                  />
                </div>
              </div>
            ))
          : null}

        <hr style={{ marginTop: '2.5rem', marginBottom: '8px' }}></hr>
        <div className='d-flex align-items-center justify-content-between '>
          <div
            className={`custom-control custom-checkbox `}
            style={{ zIndex: '0' }}
          >
            <input
              // value={admin.username}
              className='custom-control-input'
              id='emailReport'
              checked={emailReport}
              onChange={(e) => setEmailReport(!emailReport)}
              type='checkbox'
            />
            <label className='custom-control-label' htmlFor='emailReport'>
              Email report periodically
            </label>
          </div>
          <div className={`d-flex ${!emailReport ? 'invisible' : ''}`}>
            <Input
              name='period'
              onChange={(e) =>
                setEmailFrequency(
                  `${e.target.value} ${
                    emailFrequency?.split(' ')?.at(1)
                      ? emailFrequency?.split(' ')?.at(1)
                      : 'd'
                  }`
                )
              }
              // value={props.rewardPoints}
              defaultValue={
                emailFrequency?.split(' ')?.at(0)
                  ? emailFrequency?.split(' ')?.at(0)
                  : 1
              }
              className='gray-bg-input mr-2'
              type='number'
              // placeholder={'1'}
              min={1}
              style={{ height: '38px', width: '60px' }}
            />
            <Select
              options={[
                { name: 'Days', value: 'd' },
                { name: 'Weeks', value: 'w' },
              ]}
              onChange={(e) => {
                if (e.option.value === 'd')
                  setEmailFrequency(`${emailFrequency?.split(' ')?.at(0)} d`)

                if (e.option.value === 'w')
                  setEmailFrequency(`${emailFrequency?.split(' ')?.at(0)} w`)
              }}
              placeholder={
                emailFrequency?.split(' ')?.at(1) === 'd' ? 'Days' : 'Weeks'
              }
              selectedOption={
                emailFrequency?.split(' ')?.at(1) === 'd'
                  ? { name: 'Days', value: 'd' }
                  : { name: 'Weeks', value: 'w' }
              }
            />
          </div>
        </div>
      </ModalBody>
      <CustomModalFooter>
        <SubmitModalButton
          text='Save'
          customFn={() => {
            dispatch(
              updateSharedReport(modalState?.reportId, {
                emailReport,
                emailFrequency,
              })
            )
            setModalState({ show: false, reportId: null })
          }}
        />

        <SubmitModalButton
          disabled={!enableSendEmailButton}
          text='Email report to selected users'
          customFn={() => {
            dispatch(sendEmailReport(modalState?.reportId))
            // setModalState({ show: false, reportId: null })
          }}
        />
      </CustomModalFooter>
    </Modal>
  )
}

export default ShareModal
